export default "__VITE_ASSET__DnImhJ4z__"